import type { MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'

/**
 * Normalises the location's `startDayOfWeek` setting (1-7, Mon=1..Sun=7 —
 * matches the TS `StartDayOfWeek` enum) into the 0-6 scheme used by
 * UCalendar and date-fns (`weekStartsOn`: Sun=0, Mon=1, …, Sat=6).
 *
 * Defaults to Monday (1) when the setting is missing or invalid.
 */
export type WeekStartsOn = 0 | 1 | 2 | 3 | 4 | 5 | 6

export function useCalendarFirstDayOfWeek(day: MaybeRefOrGetter<number | null | undefined>) {
  return computed<WeekStartsOn>(() => {
    const value = Number(toValue(day))
    const normalised = Number.isInteger(value) && value >= 1 && value <= 7 ? value : 1

    // Sunday (enum 7) maps to 0 in the UCalendar/date-fns scheme; everything
    // else lines up directly (Mon 1→1, Tue 2→2, …, Sat 6→6).
    return (normalised === 7 ? 0 : normalised) as WeekStartsOn
  })
}
